import { TextField, List, ListItem, ListItemButton, ListItemText, IconButton } from "@mui/material";
import { useState, useCallback } from "react";
import PlacesAutocomplete, { geocodeByAddress } from "react-places-autocomplete";

import ApiRequestErrorHandler from "../../../../../global/ApiRequestErrorHandler";
import Svg from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import { useProviderSearchStore } from "../../store/providerSearchStore";

export default function CustomAddressSearchBar() {
  const store = useProviderSearchStore();
  const [local, setLocal] = useState(store.customAddressSearchText);

  const clear = useCallback(() => {
    store.setMaxDistance(store.initMaxDistance);
    store.setInitMaxDistance(0);
    store.setAssignedProvider(null);
    store.setInNetwork(1);
    store.setCustomAddressSearchText("");
    store.setAddress(null);
    setLocal("");
    const latitude = Number(store.initAddress?.additionalDetails?.latitude);
    const longitude = Number(store.initAddress?.additionalDetails?.longitude);
    store.resetCurrentPage();
    store.setSelectedCenter({lat: latitude, lng: longitude});
  }, [store]);

  const handleSelect = useCallback(
    (addr) => {
      store.setCustomAddressSearchText(addr);
      setLocal(addr);
      geocodeByAddress(addr)
        .then(([res]) => {
          const loc = res.geometry.location;
          store.setAddress({ additionalDetails: { latitude: loc.lat(), longitude: loc.lng(), state: res.address_components.find(component => component.types.includes("administrative_area_level_1"))?.short_name} });
        })
        .catch((error) => {
          console.error(error);
          return ApiRequestErrorHandler(error);
        });
    },
    [store]
  );

  return (
    <PlacesAutocomplete value={local} onChange={setLocal} onSelect={handleSelect} searchOptions={{ componentRestrictions: { country: "US" } }}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div className="relative w-full">
          <div
            className="flex items-center rounded-full border px-4 py-[2px]"
            style={{ borderColor: HNSColors.secondary[800] }}
          >
            <Svg
              name="his-magnifying-glass"
              color={HNSColors.neutrals[600]}
              sx={{ height: 20, mr: 1 }}
            />
            <TextField
              {...getInputProps({ placeholder: "Search Address" })}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": { "& fieldset": { border: "none" }, pr: "36px" },
                "& .MuiInputBase-input": { p: "8px 12px", fontSize: 14 },
              }}
            />
            {local && (
              <IconButton
                onClick={clear}
                size="small"
                sx={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)" }}
              >
                <Svg name="his-x" color={HNSColors.neutrals[600]} sx={{ width: 16, height: 16 }} />
              </IconButton>
            )}
          </div>

          {!!suggestions.length && (
            <List
              className="absolute left-0 right-0 top-full z-50 max-h-60 overflow-y-auto bg-white shadow-lg"
              sx={{
                "&::-webkit-scrollbar": { width: 6 },
                "&::-webkit-scrollbar-thumb": {
                  background: HNSColors.primary[500],
                  borderRadius: 3,
                },
              }}
            >
              {loading && <ListItem>Loading...</ListItem>}
              {suggestions.map((sug, i) => (
                <ListItem key={i} {...getSuggestionItemProps(sug)}>
                  <ListItemButton>
                    <ListItemText primary={sug.description} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          )}
        </div>
      )}
    </PlacesAutocomplete>
  );
}
